<template>
  <div id="search-question">
    <div class="wrap">
      <div v-if="isSearchListBlank">
        <div class="title">没有想要的内容？快去提问吧！</div>
        <div class="quiz" @click="$emit('feedbackProblem')">去提问</div>
      </div>
      <div v-else>
        <div class="search-list">
          <div class="search-item-first">你的提问可能已被解答</div>
          <div class="search-item"
               v-for="(item, index) in searchList"
               :class="{'selected-item': localSelectedIndex === index}"
               :key="item.id"
               @click="getQuizDetail(item.id)"
               @mouseover.prevent="handler_selectQuiz(index)">{{ item.topic }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'search-question',
  props: {
    feedbackMessage: String,
    isSearchListBlank: {
      type: Boolean,
      default: true
    },
    searchList: {
      type: Array,
      default () {
        return []
      }
    },
    selectedIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      searchTime: null,
      localSelectedIndex: 0
    }
  },
  computed: {
    ...mapGetters([
      'getCommentPageSize'
    ])
  },
  methods: {
    ...mapActions([
      'action_searchQuestionPage',
      'action_getQuestionDetails',
      'action_getQuestionMessagePage',
      'setQuestionDetail',
      'setMessageDetail'
    ]),
    handler_selectQuiz(index) {
      this.localSelectedIndex = index
    },
    getQuizDetail (id) {
      this.$router.push({path: '/help', query: {questionId: id, questionHash: Math.random()}})
    }
  },
  watch: {
    selectedIndex: {
      handler(val) {
        this.localSelectedIndex = val
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  width: 1px;
}
::-webkit-scrollbar-thumb {
  background-color: #333;
}
#search-question {}
.wrap {
  width: 686px;
  height: 297px;
  border: 1px solid #4A90E2;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(74,144,226,0.58);
  background: #fff;
}
.title {
  margin-top: 95px;
  font-size: 17px;
  color: #777777;
  text-align: center;
}
.quiz {
  width: 174px;
  height: 44px;
  margin: 29px auto 0;
  font-size: 17px;
  color: #fff;
  text-align: center;
  line-height: 44px;
  border-radius: 4px;
  background: #4A90E2;
  cursor: pointer;
}

.search-list {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow-y: hidden;
  overflow-x: hidden;
  width: 686px;
  max-height: 297px;
}
.search-list:hover {
  overflow-y: scroll;
}

.search-item {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  font-size: 15px;
  color: #333333;
  line-height: 44px;
  letter-spacing: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.search-item-first {
  width: 100%;
  padding: 0 14px;


  font-size: 15px;
  letter-spacing: 0;
  height: 34px;
  color: #777777;
  line-height: 34px;
}

.search-item, .search-item-first {
  position: relative;
}

.search-item:after, .search-item-first:after {
  position: absolute;
  content: "";
  width: 658px;
  height: 1px;
  left: 50%;
  bottom: 0;
  background: #DBDBDB;
  transform: translateX(-50%);
}

.selected-item {
  background: #4a92e2;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/search-question/search-question.vue